<ssc-layouted-overlay
  (closed)="closed.emit()"
  [title]="title"
  [subtitle]="subtitle"
  [highlightFooter]="footerColor"
  [mode]="mode"
>
  <div content>
    <ng-content></ng-content>
  </div>
  <div secondary-action>
    <dap-lib-button
      *dapLibShowForBreakpoint="'for-Large-Up'"
      variant="tertiary"
      buttonSize="medium"
      iconName="arrow-sm-left"
      iconPosition="left"
      (click)="closed.emit()"
      data-analytics="insurance-selection-overlay_close"
    >
      {{ 'COMMON.ABORT' | translate }}
    </dap-lib-button>
    <ng-container *dapLibHideForBreakpoint="'for-XSmall-Down'">
      <dap-lib-button
        (click)="closed.emit()"
        *dapLibHideForBreakpoint="'for-Large-Up'"
        class="slim"
        buttonSize="small"
        iconName="arrow-sm-left"
        iconPosition="left"
        variant="tertiary"
        data-analytics="insurance-selection-overlay_close"
      >
        {{ 'COMMON.ABORT' | translate }}
      </dap-lib-button>
    </ng-container>
    <dap-lib-background-icon
      (click)="closed.emit()"
      *dapLibShowForBreakpoint="'for-XSmall-Down'"
      iconSize="16"
      name="arrow-sm-left"
      backgroundColor="transparent"
      data-analytics="insurance-selection-overlay_close"
    ></dap-lib-background-icon>
  </div>

  <div class="contact-btn" #contactBtn contactBtn>
    <ssc-contact-btn [showContactButton]="true"></ssc-contact-btn>
  </div>

  <div *ngIf="selectionMode !== 'not available' && price" class="price-info" priceInfo>
    <div class="price">
      <span class="currency body-5">
        {{ 'COMMON.CURRENCY_PER_MONTH' | translate }}
      </span>
      <span class="amount headline-4" data-cy="monthly-price-info">
        <ssc-price [price]="price"></ssc-price>
      </span>
    </div>
  </div>

  <div *ngIf="selectionMode !== 'not available'" primary-action>
    <dap-lib-button
      (click)="selected.emit()"
      *dapLibShowForBreakpoint="'for-XXSmall'"
      buttonSize="small"
      variant="primary"
      iconPosition="left"
      [iconName]="selectionMode === 'deselect' ? 'delete' : undefined"
      [disabled]="selectionMode === 'disabled'"
      data-cy="button-overlay-continue"
      data-analytics="insurance-selection-overlay_continue"
    >
      {{ selectButtonText }}
    </dap-lib-button>
    <dap-lib-button
      (click)="selected.emit()"
      *dapLibHideForBreakpoint="'for-XXSmall'"
      buttonSize="medium"
      variant="primary"
      iconPosition="left"
      [iconName]="selectionMode === 'deselect' ? 'delete' : undefined"
      [disabled]="selectionMode === 'disabled'"
      data-cy="button-overlay-continue"
      data-analytics="insurance-selection-overlay_continue"
    >
      {{ selectButtonText }}
    </dap-lib-button>
  </div>
</ssc-layouted-overlay>
